import type { ReactNode } from 'react';
import Tooltip from '@cartwhl/ui/atoms/Tooltip';
import Text from '@cartwhl/ui/base/Text';

interface BonePropertiesBadgeProps {
  tooltipDisabled?: boolean;
  tooltipText?: ReactNode;
  tooltipAriaLabel?: string;
}

export function BonePropertiesBadge({
  tooltipDisabled = false,
  tooltipText = 'Bone has properties',
  tooltipAriaLabel = 'Bone has properties',
}: BonePropertiesBadgeProps) {
  const ariaLabel =
    tooltipAriaLabel === 'Bone has properties'
      ? tooltipAriaLabel
      : `Bone properties: ${tooltipAriaLabel}`;

  return (
    <Tooltip text={tooltipText} inModal disabled={tooltipDisabled}>
      <span
        className="inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full bg-white text-black"
        aria-label={ariaLabel}
      >
        <Text
          as="span"
          variant="studio/body/medium/xs"
          className="leading-none font-black not-italic text-black"
          style={{
            fontSize: '10px',
            fontWeight: 900,
            WebkitTextStroke: '0.25px currentColor',
          }}
        >
          P
        </Text>
      </span>
    </Tooltip>
  );
}
